<lib-menu-bar></lib-menu-bar>

<div class="main">
   <router-outlet></router-outlet>
</div>

<lib-footer showDisclaimer="true" disclaimer="beta" [version]="environment.version"></lib-footer>
